<template>
  <div class="d-flex align-center justify-start my-2">
    <v-select
      v-model="selectedChannel"
      :items="currentChannels"
      item-text="name"
      item-value="name"
      :color="clubColor"
      :label="$t('message_ChannelSelect', { type: currentModule })"
      class="channel-select ml-2"
      dense
      outlined
      hide-details
      @change="channelChanged"
    >
      <template v-slot:selection="{ item }">
        <span class="channel-text">{{ item.name }}</span>
      </template>
      
      <template v-slot:item="{ item }">
        <span class="channel-text">{{ item.name }}</span>
      </template>
    </v-select>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
export default {
  name: "ChannelSelect",
  props: {
    currentModule: String,
  },
  data() {
    return {
      selectedChannel: 'GENERAL',
      currentChannels: [],
    };
  },
  watch: {
    '$store.state.clubChannelsContributedByMe': function () {
      this.refreshList();
    },
    '$store.state.clubPublicChannels': function () {
      this.refreshList();
    },
  },
  mounted() {
    this.getCurrentChannel();
    this.refreshList();
  },
  methods: {
    getCurrentChannel() {
      this.selectedChannel = this.$store.state.currentClubChannel.name;
    },
    refreshList() {
      this.currentChannels = [{ id: -1, name: 'GENERAL' }];
      this.$store.state.clubChannelsContributedByMe.forEach((contribution) => {
        this.currentChannels.push(contribution.clubChannel);
      });
      this.currentChannels.push.apply(this.currentChannels, this.$store.state.clubPublicChannels);
    },
    ...mapMutations(['setCurrentClubChannel']),
    channelChanged(channelContributor) {
      this.selectedChannel = channelContributor.name;
      this.setCurrentClubChannel(channelContributor);
    },
  },
  computed: {
    clubColor() {
      return `#${this.$store.state.clubMember.club.primaryColor}`;
    }
  }
}
</script>

<style lang="scss" scoped>
.channel-select {
  max-width: 200px;
  font-family: 'Avenir', sans-serif;

  ::v-deep .v-input__slot {
    border-color: var(--club-color) !important;
    background-color: transparent !important;
    
    &:hover {
      border-color: var(--club-color) !important;
    }
  }

  ::v-deep .v-input__slot fieldset {
    border-color: currentColor !important;
  }

  ::v-deep .v-select__selection {
    color: var(--club-color);
    font-weight: 500;
  }

  ::v-deep .v-icon {
    color: var(--club-color) !important;
  }

  /* Active/Focus state */
  ::v-deep.v-input--is-focused {
    .v-input__slot {
      border-color: var(--club-color) !important;
    }
    
    .v-select__selection {
      color: var(--club-color) !important;
    }
  }

  /* Dropdown menu styling */
  ::v-deep .v-menu__content {
    .v-list {
      padding: 0;
      border-radius: 8px;
      
      .v-list-item {
        min-height: 40px;
        
        &:hover {
          background-color: rgba(0, 0, 0, 0.05);
        }
        
        &.v-list-item--active {
          background-color: rgba(var(--club-color-rgb), 0.1) !important;
          color: var(--club-color) !important;
        }
      }
    }
  }
}

.channel-text {
  font-family: 'Avenir', sans-serif;
  font-size: 14px;
}
</style>


